import { defineMessages } from 'react-intl';

export default defineMessages({
	errorMessageTitle: {
		defaultMessage: "Couldn't send request",
		description: 'Error message title when form submission fails',
		id: 'cv.request.create.form.error.banner.title',
	},
	errorMessageTitleForBot: {
		defaultMessage: 'We couldn’t verify that you are not a bot',
		description: 'Error message title when form submission fails due to bot validation failure',
		id: 'cv.request.create.form.error.banner.title.bot',
	},
	errorMessageText: {
		defaultMessage:
			"Please copy your text, then refresh the page and try again. If you've already tried again, {contactLink}.",
		description: 'Error message title when form submission fails',
		id: 'cv.request.create.form.error.banner.message',
	},
	errorMessageContactLink: {
		defaultMessage: 'tell us about this issue',
		description: 'Text inside the refresh link inside the error banner.',
		id: 'cv.request.create.form.error.banner.contact.link',
	},
	errorMessageOfflineText: {
		defaultMessage:
			"You've been disconnected from the internet, wait until you have connectivity and then try again.",
		description: 'Error message title when form submission fails',
		id: 'cv.request.create.form.error.banner.message.offline',
	},
	errorMessageForInternalError: {
		defaultMessage:
			'Contact your administrator to verify your internal network settings or disable any VPNs, and try again.',
		description:
			'Error message description when form submission fails due to internal tenant proxy settings',
		id: 'cv.request.create.form.error.banner.message.internal',
	},
});
